import { formatString } from "@@common";
import getNestedPropertyValue from "../../../common/getNestedPropertyValue";
import { PropertyDisplayModel } from "../../Models/PropertyDisplayModel";
import formatValue from "./formatValue";

/**
 * Checks if a date value is null, undefined, or the epoch date
 */
export function isEmptyDate(value: any): boolean {
  if (!value) return true;

  const dateStr = typeof value === "string" ? value : value.toString();
  return dateStr.startsWith("0001-01-01");
}

const formatPropertyValue = (data: Record<string, any>, property: PropertyDisplayModel, observedPaths?: string[]): string => {
  if (!!property.ValueTemplate) {
    return formatString(property.ValueTemplate, data, observedPaths);
  }

  // Support dot notation for nested property access (e.g., "user.name" accesses data.user.name)
  const value: any = property.Field ? getNestedPropertyValue(property.Field, data) : data;

  // Collect observed path if requested
  if (observedPaths !== undefined && property.Field) {
    observedPaths.push(property.Field);
  }

  return formatValue(value, property.Format, property.CurrencyCode);
};

export default formatPropertyValue;
